// extracted by mini-css-extract-plugin
export var buttons = "_9k-0";
export var buttonsActive = "_9k-h";
export var cancelConfirm = "_9k-1";
export var closeButton = "_9k-2";
export var column = "_9k-3";
export var container = "_9k-4";
export var detailHeader = "_9k-6";
export var detailTitle = "_9k-7";
export var detailsContent = "_9k-5";
export var header = "_9k-8";
export var headerWithClose = "_9k-9";
export var icon = "_9k-a";
export var infoIcon = "_9k-c";
export var informationContainer = "_9k-b";
export var sideDrawer = "_9k-d";
export var sideDrawerOpen = "_9k-e";
export var stickyFooter = "_9k-f";
export var typeOption = "_9k-g";